import React, { useEffect, useState, useMemo ,useRef } from "react";
import CustomButton from "../../AppComponent/CustomButton/CustomButton";
import "../../../StyleSheet/MainComponent/Role/Role.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  getRoleListActions,
  SetRoleDeleteCalActions,
  getSideBarfilesActions,
  setTheRoleObjects,
  setTheemployeeRoleId,
  setTheGrossSalary,
  setClientBranchActions,
  setaRoleChnage,
  setTheDesignationMonthAndyearFilter,
  setTablePositionPersist,
  setClient_options_inRole_list,
  setEmployee_filter_inRole
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import RoleCreateForm from "./RoleCreateForm";
import Delete from "../../AppComponent/Popup/Delete";
import RoleEdits from "../../AppComponent/Popup/Edits/RoleEdits";
import data from "../../../Json/Language/English";
import hindiDatas from "../../../Json/Language/Hinid";
import { NavLink, useNavigate } from "react-router-dom";
import Select from "react-select";
import _ from "lodash";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import useDebouncedEffect from 'use-debounced-effect';

const Role = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [Data, setdatas] = useState([]);
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [RoleCreatePopup, setRoleCreatePopup] = useState(false);
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
    const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist
  );
    const [search, setsearch] = useState(
    TablePositionPersist?.DesginationStates?.search =="" || TablePositionPersist?.DesginationStates?.search == undefined
      ? ""
      : TablePositionPersist.DesginationStates.search
  );

  const [DeletePopup, setDeletepopup] = useState(false);
  const [DeleteId, setDeleteID] = useState();
  const [EditPopupCall, setEditPopup] = useState(false);
  const [EditID, setEditId] = useState();
const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.DesginationStates?.page == undefined
      ? 1
      : TablePositionPersist.DesginationStates.page
  );  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState(1);
  const EnglishData = data;
  const HindiData = hindiDatas;
  const [columnfilter, setColumns] = useState([]);
  const [nameList4, setOptions4] = useState([]);
  const naviagte = useNavigate();
  const [clients, setclientid] = useState({ client: state.NumberCounts.Client_list_from_role != null  ? state.NumberCounts.Client_list_from_role?.value : "" });
  const initialStateSearch = {
    client: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    client:""
  };
 


  const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);

  useEffect(() => {
    dispatch(setaRoleChnage(1));
  }, []);
  const [yearAndMonth, setYearMpnth] = useState();
 

  const [Datamonth, setdata] = useState({
    month:
      state.StateManagementOverallCall.RoleMonthYearFilter?.month,
    year: state.StateManagementOverallCall.RoleMonthYearFilter
      ?.year,  });



      const date = new Date();
      const months =
        date.getMonth() < 10 ? `0${date.getMonth() + 1}` : date.getMonth() +1;
      const stateManagemonth =
        state.StateManagementOverallCall.RoleMonthYearFilter?.month < 10
          ? `0${state.StateManagementOverallCall.RoleMonthYearFilter?.month}`
          : state.StateManagementOverallCall.RoleMonthYearFilter?.month;
      const statemanageyear =
        state.StateManagementOverallCall.RoleMonthYearFilter?.year;
      useEffect(() => {
        if (Datamonth.month == "") {
          setYearMpnth(`${date.getFullYear()}-${months}`);
        } else {
          setYearMpnth(`${statemanageyear}-${stateManagemonth}`);
        }
      }, []);
      console.log(state.StateManagementOverallCall.RoleMonthYearFilter ,"RoleMonthYearFilter" );
      
  ////---- end of the filters
  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "",
      label: "ALL",
    },
    {
      value: "1",
      label: "QPMS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);

  const [EMpROleSelected, setEmpRoleSele] = useState(state.StateManagementOverallCall?.Employeee_designation_filter  ?  state.StateManagementOverallCall?.Employeee_designation_filter : EmpRoles[0]);
  const [filterForWhite, setFilters] = useState({ white_collar: state.StateManagementOverallCall?.Employeee_designation_filter ? 
    state.StateManagementOverallCall?.Employeee_designation_filter?.value == "" ? "" :
    state.StateManagementOverallCall?.Employeee_designation_filter?.value == 1 ? true : false
    
    
    
    : "" });
  // console.log(filterForWhite.white_collar, "asdasdasudupayloads");

  ///------------------Role-----Action
  useEffect(() => {
    const payloads = {
      search: search,
      page_size: 20,
      page: dtpageindex,
      mode: "all",
      client: clients.client,
      // white_collar: state.NumberCounts.Rolechanges == 1 ? true : false,
      white_collar: filterForWhite.white_collar,
      month: Datamonth.month,
      year: Datamonth.year,
    };
  // if (
  //     state.rolelists.RoleList.length == 0 ||
  //     TablePositionPersist?.DesginationStates?.search != search ||

  //     TablePositionPersist?.DesginationStates?.page != dtpageindex ||
  //     TablePositionPersist?.DesginationStates?.white_collar !== filterForWhite.white_collar ||
  //     TablePositionPersist?.DesginationStates?.year != Datamonth.year ||
  //     TablePositionPersist?.DesginationStates?.month != Datamonth.month ||

  //     TablePositionPersist?.DesginationStates?.client != clients.client ||
  //     TablePositionPersist?.DesginationStates?.updated
  //     // apiTriggerCount == true
  //   ) {  

    dispatch(getRoleListActions(payloads));

    dispatch(
      setTablePositionPersist({ data: payloads, pageName: "DesginationStates" })
    );
  // }
    currentRef.current.scrollTop=sessionStorage.getItem("DesginationPageTableScrollPosition")

    setdatas(state.rolelists.RoleList);
  }, [
    clients.client,
    dtpageindex,
    filterForWhite.white_collar,
    Datamonth,
    search,
    // state.NumberCounts.Rolechanges,
  ]);

  const HandleEMprole = (e) => {
    if (e != null) {
      setEmpRoleSele(e);
      setdtPageindex(1);
      dispatch(setEmployee_filter_inRole(e))

      if (e.value == 1) {
        // dispatch(setaRoleChnage(1));
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });
        setclientid({
          ...clients,
          client: "",
        });
      } else if (e.value == 2) {
        // dispatch(setaRoleChnage(2)); ///Role based dispatch for the white_collar
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
      } else if (e.value == "") {
        setFilters({
          ...filterForWhite,
          white_collar: "",
        });
      }
    }
  };

  ///-----Month and yar based filter
  ////------month and year based filters-------------------------------
  // const handleChange = (e) => {
  //   setdtPageindex(1);

  //   const months = new Date(e.target.value);
  //   const selectedmonth =
  //     months.getMonth() < 10
  //       ? `0${months.getMonth() + 1}`
  //       : months.getMonth() + 1;

  //   setYearMpnth(`${months.getFullYear()}-${selectedmonth}`);
  //   setdata({
  //     ...Datamonth,
  //     month: months.getMonth() + 1,
  //     year: months.getFullYear(),
  //   });
  //   dispatch(
  //     setTheDesignationMonthAndyearFilter({
  //       month: months.getMonth() + 1,
  //       year: months.getFullYear(),
  //     })
  //   );
  // };


  const handleChange = (e) => {
    const inputValue = e.target.value;
    // setMonthYear(inputValue);
    // setMonthFilter(true);
    setdtPageindex(1);
  
    const months = new Date(inputValue);
    
    // Validate date before proceeding
    if (isNaN(months.getTime())) {
      console.error("Invalid date selected");
      return;
    }
  
    const selectedMonth = String(months.getMonth() + 1).padStart(2, "0"); // Ensures 2-digit format
    const selectedYear = months.getFullYear();
  
    setYearMpnth(`${selectedYear}-${selectedMonth}`);
    console.log(selectedYear, "weurweydsfsd", selectedMonth);
  
    setdata({
      ...Datamonth,
      month: selectedMonth,
      year: selectedYear,
    });
  
    dispatch(
          setTheDesignationMonthAndyearFilter({
            month: selectedMonth,
            year: selectedYear,
          })
        );
    console.log({ month: selectedMonth, year: selectedYear }, "Date filters");
  };

  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearched({
          ...SearchedVal,
          client: SearchDebounance.client,
        });
      }
    },
    500,
    [SearchDebounance]
  );


  const handleInputChangeClinet = (Val) => {
    // console.log(Val, "Values");

   
    setSearchDebounance({
      ...SearchDebounance,
      client: Val,
  
    });
  };

  ////---Client-----Branch====--based----filter
  useEffect(() => {
    const payload = {
      search: SearchedVal.client,
      page_size: 20,
      page: 1,
      // client: "",
      // month: Datamonth.month,
      // year: Datamonth.year,
    };
    dispatch(setClientBranchActions(payload));
  }, [SearchedVal.client]);

  useEffect(() => {
    if (state.ClientBranch.ClientBranchess != undefined) {
      let objectArray = [];
      state.ClientBranch.ClientBranchess.forEach((element) => {
             objectArray.push({
          value: element.id,
          label: element.branch_code
          ? `${element.branch_code}-${element.client_name.toUpperCase()}`
          : element.client_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.ClientBranch.ClientBranchess, SearchedVal.client]);

  const HandleClientBranches = (selectedVal) => {
    // console.log(selectedVal.value, "va;lusfodcn ");
    setdtPageindex(1);
    if (selectedVal != null) {
      setclientid({
        ...clients,
        client: selectedVal.value,
      });
          dispatch(setClient_options_inRole_list(selectedVal))

    } else {
      setclientid({
        ...clients,
        client: "",
      });
          dispatch(setClient_options_inRole_list({value:"",lable:"All"}))

    }
  };

  const HandelDelete = () => {
              setsearch("");
          setdtPageindex(1)
         const payloads_tocall = {
          search: "",
          page_size: 20,
          page: 1,
          client: state.ClientBranchIDs.clientID,
          };
          dispatch(setTablePositionPersist({data:payloads_tocall,pageName:"DesginationStates"}))
    
    
    if (DeleteId != undefined) {
      console.log(currentPage, "sdsd");
      const payload = {
        DeleteId: DeleteId,
        currentPage: currentPage,
        mode: "all",
        client: clients.client,
        // white_collar:state.NumberCounts.Rolechanges == 1 ? true : false
        white_collar: filterForWhite.white_collar,
        // white_collar: state.NumberCounts.Rolechanges == 1 ? true : false,

        month: Datamonth.month,
        year: Datamonth.year,
      };
      console.log(payload, "86987payload");
      dispatch(SetRoleDeleteCalActions(payload, setDeletepopup(false)));
    }
  };

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };
  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + "...";
  };

  const columns = [
    {
      Header: "Designation",
      accessor: "",
      Cell: (row) => {
        const [showTooltip, setShowTooltip] = useState(false);

        return (
          <>
            <span>
              {row.row.original.role != null &&
              row.row.original.role != undefined &&
              row.row.original.role != "" ? (
                <div
                  className="UserName"
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                  style={{ position: "relative" }}
                >
                  <>
                    {
                      // row.row.original.role.length > 10 ? (
                      //   truncateText(row.row.original.role, 10)
                      // ) :
                      <>{row.row.original.role}</>
                    }
                  </>
                  {showTooltip && (
                    <div className="custom-tooltip">
                      {row.row.original.role}
                    </div>
                  )}
                </div>
              ) : (
                <span>{"---"} </span>
              )}
            </span>
          </>
        );
      },
    },
    {
      Header: "Description",
      accessor: "",
      Cell: (row) => {
        const [showTooltip, setShowTooltip] = useState(false);

        return (
          <>
            <>
              {row.row.original.description != null &&
              row.row.original.description != undefined &&
              row.row.original.description != "" ? (
                <div
                  className="UserName"
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                  style={{ position: "relative" }}
                >
                  <span>
                    {
                      // row.row.original.description.length > 10 ? (
                      //   truncateText(row.row.original.description, 10)
                      // ) :
                      <>{row.row.original.description}</>
                    }
                  </span>
                  {showTooltip && (
                    <div className="custom-tooltip">
                      {row.row.original.description}
                    </div>
                  )}
                </div>
              ) : (
                <span>{"---"} </span>
              )}
            </>
          </>
        );
      },
    },
    {
      Header: "Employee Designation",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div className="CreatedDatelisted">
              {row.row.original.white_collar != null ? (
                <>
                  {row.row.original.white_collar ? (
                    <>{"QPMS"}</>
                  ) : (
                    <>{"CLIENT"}</>
                  )}
                </>
              ) : (
                <>{"---"} </>
              )}
            </div>
          </>
        );
      },
    },

    {
      Header: "Position Number",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div className="CreatedDatelisted">
              {row.row.original.position_number != null &&
              row.row.original.position_number != "" ? (
                <>{row.row.original.position_number}</>
              ) : (
                <>{"---"} </>
              )}
            </div>
          </>
        );
      },
    },

    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <div className="CreatedDatelisted">
              {`${row.row.original.created_at.slice(0, 10) }`}
            </div>
          </>
        );
      },
    },

    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              <button
                className=" btn Status"
                onClick={(e) => {
                  setEditId(row.row.original.id);
                  setEditPopup(true);
                }}
                component="span"
              >
                <span className="OuterActionSpan">
               
                  <span className="EditImages">
                    <img src={EditImages} />
                  </span>
                  <span className="ActionsList"> Edit </span>
                </span>
              </button>

              <button
                type="button"
                class="btn Status"
                onClick={(e) => {
                  setDeleteID(row.row.original.id);
                  setDeletepopup(true);
                }}
              >
                <span className="OuterActionSpan">
                 
                  <span className="EditImages">
                    <img src={DeleteImages} />
                  </span>
                  <span className="ActionsList"> Delete </span>
                </span>
              </button>
            </div>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    // Check your condition here to hide the column
    if (
      state.NumberCounts.Rolechanges === 2 &&
      state.SideBarFiles.SideBarFile != "Role"
    ) {
      const filteredColumns = columns.map((column) => {
        if (column.Header === "Actions") {
          return {
            ...column,
            show: false,
          };
        }
        return column;
      });
      setColumns(filteredColumns);
    }
  }, []);

  // useEffect(()=>{
  /// if(state.NumberCounts.Rolechanges === 2){

  const reducedColumns = columns.reduce((acc, column) => {
    if (state.SideBarFiles.SideBarFile != "Role") {
      if (column.Header !== "Actions") {
        acc.push(column);
      }
    }
    return acc;
  }, []);
  //}
  // },[])

  useEffect(() => {
    // Check your condition here to hide the column
    if (
      state.NumberCounts.Rolechanges != 1 ||
      state.SideBarFiles.SideBarFile == "Role"
    ) {
      const reducedColumns = columns.reduce((acc, column) => {
        if (column.Header !== "Actions") {
          acc.push(column);
        }
        return acc;
      }, []);
      setColumns(reducedColumns);
    }
  }, [state.NumberCounts.Rolechanges]);
  // console.log(columnfilter, "sdasdahsdhiu");

  const handlePageSizeChange = (newPageSize) => {
    console.log("New Page Size:", newPageSize);
  };

  ///----Page---Changes----
  // const handlePageChange = (page) => {
  //     setCurrentPage(page);
  //     const pageEntries = {
  //         search: search,
  //         page_size: 10,
  //         page: page,
  //     }
  //     dispatch(getRoleListActions(pageEntries))

  // };

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        console.log(clients.client, "2398e");
        const clientid = clients.client;

        // const payloads = {
        //   search: e,
        //   page_size: 10,
        //   page: dtpageindex,
        //   mode: "all",
        //   client: clients.client,
        //   // white_collar: state.NumberCounts.Rolechanges == 1 ? true : false,
        //   white_collar: filterForWhite.white_collar,
        //   month: Datamonth.month,
        //   year: Datamonth.year,
        // };
        // // console.log(e, "testnew")
        // dispatch(getRoleListActions(payloads));
        setsearch(e);
      }, 500),
    []
  );

  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);

    // if (e.trim() != undefined && e.trim() != "") {
    //   const payload = {
    //     search: e.trim(),
    //     page_size: dtpagesize,
    //     page: 1,
    //     mode: "all",
    //     client: clientid,
    //     // white_collar:state.NumberCounts.Rolechanges == 1 ? true : false
    //     white_collar: filterForWhite.white_collar,
    //   };
    //   // console.log(e, "testnew")
    //   dispatch(getRoleListActions(payload));
    // }
    // if (e == "" || search == "") {
    //   const payload = {
    //     search: "",
    //             page_size: dtpagesize,
    //     page: 1,
    //     mode: "all",
    //     client: clientid,
    //     // white_collar:state.NumberCounts.Rolechanges == 1 ?true : false
    //     white_collar: filterForWhite.white_collar,
    //   };
    //   dispatch(getRoleListActions(payload));
    // }
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  ///-for-Filed-agent--B-route----to --the--role--then---employee-list
  const handleClick = (e) => {
    console.log(e, "wedfcdcn");
    dispatch(setTheGrossSalary(e.salary));
    dispatch(setTheRoleObjects({ value: e.id, label: e.role }));
    dispatch(setTheemployeeRoleId(e.id));
    console.log(state.NumberCounts.RoleOjects, "RoleOjects");
    if (
      e.id == state.NumberCounts.EmployeeRoleId &&
      state.NumberCounts.RoleOjects != undefined
    ) {
      naviagte("/managerlist");
    }
  };
  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage);
  };

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
    }
  };
  const currentRef = useRef();
  const scrollPosition = (e) => {
    const val = currentRef.current.scrollTop;
    sessionStorage.setItem("DesginationPageTableScrollPosition", val);
  };
  return (
    <>
      <div 
            onScroll={scrollPosition}
      ref={currentRef}      

      className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Designation</h3>

            {/* {state.NumberCounts.Rolechanges == 1 ||
            state.SideBarFiles.SideBarFile == "Designation" ? (
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/designation"}
                    onClick={(e) => {
                      dispatch(getSideBarfilesActions("Designation"));
                    }}
                  >
                    Designation
                  </NavLink>
                </li>
              </ul>
            ) : (
              <>
                {state.SideBarFiles.SideBarFile != "Designation" &&
                state.NumberCounts.Rolechanges == 1 ? (
                  <>
                    <ul class="breadcrumb">
                      <li class="breadcrumb-item">
                        <NavLink
                          style={{ textDecoration: "none", color: "#333333" }}
                          to={"/fieldagent"}
                          onClick={(e) => {
                            dispatch(getSideBarfilesActions("Onboarding"));
                          }}
                        >
                          Onboarding
                        </NavLink>
                      </li>

                      <li class="breadcrumb-item">
                        <NavLink
                          style={{ textDecoration: "none", color: "#333333" }}
                          to={"/designation"}
                          onClick={(e) => {
                            dispatch(getSideBarfilesActions("Field Agent"));
                          }}
                        >
                          Role
                        </NavLink>
                      </li>
                    </ul>
                  </>
                ) : null}
              </>
            )} */}
          </div>
          <div className="Add-User col-sm-5">
            <button
              onClick={(e) => setRoleCreatePopup(true)}
              className="ButtonCSS "
            >
              Create
            </button>
          </div>
        </div>
        {!filterForWhite.white_collar ? (
          <div
            className="row Filters"
            style={{
              padding: "15px 28px",
              margin: "0px",
              position: "relative",
              // zIndex: "30",
              marginTop: "-30xp",
              marginLeft: "0px",
              marginRight: "0px",
              top: "-7px",
            }}
          >
            <div className="col-sm-2 field-div">
              <label for="validationCustom01" class="form-label">
                Client
              </label>
              <Select
                className="Selects"
                styles={{ position: "relative", top: "60px" }}
                onChange={(e) => {
                  HandleClientBranches(e);
                }}
                filterOption={() => true}
                isClearable="true"
                options={nameList4}
                onInputChange={handleInputChangeClinet}
                placeholder="search"
                value={state.NumberCounts.Client_list_from_role}
              />
            </div>
          </div>
        ) : null}
        {Data != undefined ? (
          <div
            // style={{ padding: " 0px 40px", marginTop: "-13px" }}
            style={{ padding: " 0px 40px", }}
          >
            <ReactTable
              data={state.rolelists.RoleList}
              columns={
                state.NumberCounts.Rolechanges == 2 &&
                state.SideBarFiles.SideBarFile != "Role"
                  ? columnfilter
                  : columns
              }
              totalItems={state.rolelists.Total_Count}
              currentPage={currentPage}
              // onPageChange={handlePageChange}
              onChange={tochange}
              setCurrentPage={setCurrentPage}
              pagesize={pagesize}
              onPrevious={handlePrevious}
              onNextpage={handleNext}
              GotoEnteredPage={GotoEnteredPage}
              dtpagesize={pageSize}
              // dtpageindex={currentPage}

              dtpageindex={dtpageindex}
              pageindex={pageindex}
              datacount={state.rolelists.Total_Count}
              // MakeCreate={state.NumberCounts.Rolechanges == 2 ? true : false}
              // ViewParts={(e) => {
              //   handleClick(e);
              // }}

              MakeCreate={false}
              //---Month based filter
              // MonthFilter={true}
              // yearAndMonth={yearAndMonth}

                Month_date_pick={true}
                                    nostatusFilter={true}
                                    value_of_monthDate={Datamonth}
onChange_ofMonthDate={setdata}  
              handleChange={handleChange}
              Filter={true}
              Superviorsfilter={false}
              OldEmployeFilters={false}
              // nostatusFilter={true}
              ///----
              ///--- emoloyee role based filters -
              EmployeeRoleTrue={true}
              EmployeeRoleOption={EmpRoles}
              EMpROleSelected={EMpROleSelected}
              HandleEMprole={HandleEMprole}
                             searchVal={TablePositionPersist?.DesginationStates?.search == "" || TablePositionPersist?.DesginationStates?.search ==undefined? "":TablePositionPersist.DesginationStates.search}
              search_key={true}

            />
          </div>
        ) : null}
      </div>
      {RoleCreatePopup ? (
        <RoleCreateForm
          setShow={setRoleCreatePopup}
          show={RoleCreatePopup}
          Datamonth={Datamonth}
          currentPage={newpages}
          EMpRole={EMpROleSelected}
          white_collar_List={filterForWhite.white_collar}
          search={search}
        />
      ) : null}

      {DeletePopup ? (
        <Delete
          show={DeletePopup}
          setShow={setDeletepopup}
          onSubmit={HandelDelete}
          Content={"Do you want to delete the Designation"}
        />
      ) : null}

      {EditID != undefined && currentPage != undefined && EditPopupCall ? (
        <RoleEdits
          show={EditPopupCall}
          setShow={setEditPopup}
          Datamonth={Datamonth}
          EditID={EditID}
          currentPage={newpages}
          search={search}
          white_collar_List={filterForWhite.white_collar}
        />
      ) : null}
    </>
  );
};

export default Role;
